import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";

declare global {
  interface Window { dataLayer: unknown[]; gtag?: (...args: unknown[]) => void; }
}

let measurementId: string | null = null;
let loading: Promise<string | null> | null = null;

function init(): Promise<string | null> {
  if (loading) return loading;
  loading = supabase.functions.invoke("ga-config").then(({ data }) => {
    const id = (data as any)?.id as string | undefined;
    if (!id) return null;
    const s = document.createElement("script");
    s.async = true;
    s.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
    document.head.appendChild(s);
    window.dataLayer = window.dataLayer || [];
    window.gtag = function () {
      // eslint-disable-next-line prefer-rest-params
      window.dataLayer.push(arguments);
    };
    window.gtag("js", new Date());
    window.gtag("config", id, { send_page_view: false });
    measurementId = id;
    return id;
  }).catch(() => null);
  return loading;
}

const GoogleAnalytics = () => {
  const location = useLocation();
  const last = useRef("");
  useEffect(() => {
    const path = location.pathname + location.search;
    init().then((id) => {
      if (!id || !window.gtag || last.current === path) return;
      last.current = path;
      window.gtag("event", "page_view", {
        page_path: path,
        page_location: window.location.href,
        page_title: document.title,
      });
    });
  }, [location.pathname, location.search]);
  return null;
};

export default GoogleAnalytics;
